import React from 'react';

import SearchTeaser from '../../../components/SearchTeaser';
import NodeVacancyDetail from './Detail';

const NodeVacancy = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'search_teaser':
      return <SearchTeaser entity={entity} />;
    case 'full':
    default:
      return <NodeVacancyDetail entity={entity} />;
  }
};

export default NodeVacancy;
